export default __webpack_public_path__ + "static/media/19.d255aa57.jpg";